// ----------------------------------------------------------------------
// <copyright file="Izenda.QuerySourceTypeConfig.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import localizer from 'share/localization/Izenda.Localizer';

export default {
  QUERY_SOURCE_TYPE: {
    TABLE: 'Table',
    VIEW: 'View',
    FUNCTION: 'Function',
    STORED_PROC: 'Stored Procedure'
  },

  STORED_PROC_TYPE: {
    STATIC: 'STATIC',
    DYNAMIC: 'DYNAMIC',
    NON_DYNAMIC: 'NON_DYNAMIC'
  },

  FIELD_TYPE: {
    SCHEMA: 0,
    PARAM: 1
  },

  FILTER_TYPE: {
    DB_STRUCTURE: '1',
    USER_DEFINED: '2'
  },

  BUNDLE: {
    MESSAGE: {
      get MG01() {
        return localizer.getText('QUERY_SOURCE_TYPE_CONFIG_MESSAGE_REQUIRE_PARAMETER');
      },
      get MG02() {
        return localizer.getText('QUERY_SOURCE_TYPE_CONFIG_MESSAGE_CHANGE_PROCEDURE_TYPE');
      },
      get MG03() {
        return localizer.getText('QUERY_SOURCE_TYPE_CONFIG_MESSAGE_CHANGE_FIELD');
      }
    },

    CRITERIALIST: {
      Function: [
        {
          value: 'All',
          get label() {
            return localizer.getText('COMMON_LABEL_ALL');
          }
        },
        {
          value: 'DatabaseName',
          get label() {
            return localizer.getText('QUERY_SOURCE_TYPE_CONFIG_LABEL_CRITERIALIST_DATABASE_NAME');
          }
        },
        {
          value: 'DataSourceName',
          get label() {
            return localizer.getText('QUERY_SOURCE_TYPE_CONFIG_LABEL_CRITERIALIST_FUNCTION_NAME');
          }
        }
      ],
      DEFAULT_CRITERIA_LIST: [
        {
          value: 'All',
          get label() {
            return localizer.getText('COMMON_LABEL_ALL');
          }
        },
        {
          value: 'Category',
          get label() {
            return localizer.getText('QUERY_SOURCE_TYPE_CONFIG_LABEL_DEFAULT_CRITERIA_LIST_CATEGORY');
          }
        },
        {
          value: 'DatabaseName',
          get label() {
            return localizer.getText('QUERY_SOURCE_TYPE_CONFIG_LABEL_DEFAULT_CRITERIA_LIST_DATABASE_NAME');
          }
        },
        {
          value: 'DataSourceName',
          get label() {
            return localizer.getText('QUERY_SOURCE_TYPE_CONFIG_LABEL_DEFAULT_CRITERIA_LIST_DATA_SOURCE_NAME');
          }
        },
        {
          value: 'DataSourceAlias',
          get label() {
            return localizer.getText('QUERY_SOURCE_TYPE_CONFIG_LABEL_DEFAULT_CRITERIA_LIST_DATA_SOURCE_ALIAS');
          }
        },
        {
          value: 'ColumnName',
          get label() {
            return localizer.getText('QUERY_SOURCE_TYPE_CONFIG_LABEL_DEFAULT_CRITERIA_LIST_COLUMN_NAME');
          }
        },
        {
          value: 'ColumnAlias',
          get label() {
            return localizer.getText('QUERY_SOURCE_TYPE_CONFIG_LABEL_DEFAULT_CRITERIA_LIST_COLUMN_ALIAS');
          }
        }
      ]
    },

    SORTDEFAULTLIST: {
      Function: { DatabaseName: 'DESC' },
      DEFAULT_SORT: { Category: 'DESC' }
    },

    DEFAULT_CRITERIA: 'All'
  }
};



// WEBPACK FOOTER //
// ./ui/logic/data/Izenda.QuerySourceTypeConfig.js